import { z } from "zod"

/** Output shape of a marketplace attribute. Length limits are separate. */
export const attributeFormatSchema = z.enum([
  "plain",
  "markdown",
  "html",
  "enum",
  "list_enum",
  "number",
  "image_url",
  "date",
  "raw",
])

export type AttributeFormat = z.infer<typeof attributeFormatSchema>
